export const PURPLE = "#5c4fd6";
export const PURPLE_DARK = "#3d3580";
export const PAGE_BG = "#f0f2f8";

export const LEAD_PRIORITIES = [
  { value: "low", label: "Low" },
  { value: "normal", label: "Normal" },
  { value: "high", label: "High" },
  { value: "urgent", label: "Urgent" },
];

export const REMINDER_FREQUENCIES = [
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "yearly", label: "Yearly" },
];

export const DAY_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export function getStageAccent(stage) {
  if (stage?.is_won) {
    return { accent: "#2e7d32", bg: "#f4faf5", header: "#e8f5e9", chip: "#a5d6a7" };
  }
  if (stage?.is_lost) {
    return { accent: "#c62828", bg: "#fef6f5", header: "#fdecea", chip: "#ef9a9a" };
  }
  const name = (stage?.name || "").toLowerCase();
  const map = {
    new: { accent: "#5c4fd6", bg: "#f6f4fd", header: "#ebe8f8", chip: "#c5bdf5" },
    contacted: { accent: "#1565c0", bg: "#f3f7fd", header: "#e3eefb", chip: "#90caf9" },
    qualified: { accent: "#6a1b9a", bg: "#f9f4fd", header: "#f0e6f8", chip: "#ce93d8" },
    proposal: { accent: "#e65100", bg: "#fffaf3", header: "#fff0e0", chip: "#ffcc80" },
  };
  return map[name] || map.new;
}

export const LEAD_CATEGORY_COLORS = [
  "#5c4fd6",
  "#1565c0",
  "#2e7d32",
  "#e65100",
  "#6a1b9a",
  "#c62828",
  "#00838f",
  "#6d4c41",
];

export function getCategoryColor(category) {
  return category?.color || category?.category_color || PURPLE;
}

export function getPriorityAccent(priority) {
  switch (priority) {
    case "urgent":
      return "#d32f2f";
    case "high":
      return "#ed6c02";
    case "low":
      return "#90a4ae";
    default:
      return PURPLE;
  }
}

export function priorityColor(priority) {
  switch (priority) {
    case "urgent":
      return "error";
    case "high":
      return "warning";
    case "low":
      return "default";
    default:
      return "primary";
  }
}

export function formatReminderTime(timeOfDay) {
  if (!timeOfDay) return "—";
  const [h, m] = timeOfDay.split(":");
  const date = new Date();
  date.setHours(parseInt(h, 10), parseInt(m, 10), 0, 0);
  return date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

export function getInitials(name) {
  if (!name) return "?";
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("");
}

export function timeAgo(dateStr) {
  if (!dateStr) return "";
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} hr ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days} day${days === 1 ? "" : "s"} ago`;
  return formatDateTime(dateStr);
}

export function formatDateTime(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function formatTime(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
}

export function formatDateTimeWithAgo(dateStr) {
  if (!dateStr) return "—";
  const clock = formatDateTime(dateStr);
  const ago = timeAgo(dateStr);
  if (!ago || ago === clock) return clock;
  return `${clock} · ${ago}`;
}

export function formatReminderSchedule(reminder) {
  if (reminder.frequency === "daily") return "Every day";
  if (reminder.frequency === "weekly") {
    return DAY_NAMES[reminder.day_of_week] || "—";
  }
  if (reminder.frequency === "yearly") {
    const month = MONTH_NAMES[(reminder.month || 1) - 1] || "—";
    return `${month} ${reminder.day_of_month || "—"}`;
  }
  return "—";
}
